import { lazy, Suspense } from 'react';
import { FEATURE_FLAGS } from '@/config/featureFlags';
import { validatePlan } from '../../../../supabase/functions/_shared/personalActionDomain';
import type { ActionPlanPrefill } from '@/components/actions/ActionPlanBuilder';
import type { ModuleCaptureHandler } from '@/lib/capture/types';
const PersonalActionModal = lazy(() => import('@/components/mirror/PersonalActionModal').then(m => ({ default: m.PersonalActionModal })));
export const personalActionCaptureHandler: ModuleCaptureHandler<ActionPlanPrefill> = {
  tool: 'propose_personal_action',
  isEnabled: () => FEATURE_FLAGS.PERSONAL_ACTION_ENGINE_ENABLED,
  getRawText: proposal => proposal.tool === 'propose_personal_action' ? JSON.stringify(proposal.args) : '',
  extract: async (_raw, proposal) => {
    if (proposal.tool !== 'propose_personal_action') return null;
    try { const plan = validatePlan({ ...proposal.args, client_action_id: proposal.action_id }); return { action_id: proposal.action_id, title: plan.title, steps: plan.steps }; } catch { return null; }
  },
  renderModal: props => <Suspense fallback={null}><PersonalActionModal {...props} /></Suspense>,
};
